import { Api } from 'models/services/api';
import { DeleteBrandQuery } from 'models/services/graphql';

import { BrandData } from '../index';

type DataToDelete = {
  id: string;
};

const RequestQuery = `
  mutation DeleteBrand($id: ID!) {
    ${DeleteBrandQuery}
  }
`;

type ResponseData = {
  data: {
    deleteBrand: BrandData
  }
}

class DeleteGql {

  readonly api: Api<ResponseData>;
  readonly document?: BrandData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToDelete): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.deleteBrand;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { DeleteGql };